import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth
    const storedUser = localStorage.getItem('dashboard_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const signIn = (email, password) => {
    // Mock authentication - replace with real auth
    const mockUser = {
      id: 1,
      name: 'Team Member',
      email: email,
      role: 'admin',
      permissions: {
        inventory: ['read', 'write'],
        tasks: ['read', 'write'],
        calendar: ['read', 'write'],
        roles: ['read', 'write']
      }
    };
    setUser(mockUser);
    localStorage.setItem('dashboard_user', JSON.stringify(mockUser));
    return true;
  };

  const signOut = () => {
    setUser(null);
    localStorage.removeItem('dashboard_user');
  };

  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

